const profile = {
    name: 'Name',
    avatar: 'Avatar',
    givenName: 'Given Name',
    familyName: 'Family Name',
    middleName: 'Middle Name',
    fullName: 'Full Name',
    nickname: 'Nickname',
    preferredUsername: 'Preferred Username',
    profile: 'Profile',
    website: 'Website',
    gender: 'Gender',
    birthdate: 'Birthdate',
    zoneinfo: 'Zoneinfo',
    locale: 'Locale',
    address: {
        formatted: 'Address',
        streetAddress: 'Street address',
        locality: 'City',
        region: 'State/Province',
        postalCode: 'Zip code',
        country: 'Country',
    },
};
export default Object.freeze(profile);
